import check from "../assets/img/check.png";

export const REMITTANCE_SIGNUP = "remittance";
export const ABOUND_PERKS = [
    { text: "Automatic cashback on 4000+ stores", logo: check },
    { text: "Highest FX rates on all your transfers to India", logo: check },
  ];